<template>
  <div class="perf-header" v-if="item">
    <div class="container d-md-flex flex-md-row-reverse pa-0">
      <div class="image" :style="{ backgroundImage: `url(${item.image})` }"></div>
      <div class="content">
        <div class="upper">
          <div class="line-two">{{ item.subTitle }}</div>
          <div class="line-one">{{ item.title }}</div>
        </div>
        <div class="lower">
          <div class="line-three"><v-icon color="#fff" class="mr-3">mdi-clock-outline</v-icon>{{ $moment(item.date).format("llll") }}</div>
          <div class="line-three"><v-icon color="#fff" class="mr-3">mdi-map-marker-outline</v-icon>{{ item.location }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object
  }
};
</script>

<style lang="scss">
.perf-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  > .container {
    .content {
      color: #fff;
      > div {
        height: 50%;
        padding: 1em;
      }
      > .upper {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        background: var(--background-red);
        .line-two {
          font-size: 20px;
          line-height: 1;
          margin-bottom: 1em;
        }
        .line-one {
          font-size: 24px;
          line-height: 1.5;
        }
      }
      > .lower {
        background: var(--background-dark);
      }
    }
    .image {
      height: 65vw;
      background-position: center;
      background-size: cover;
    }
  }
}
@media (min-width: 960px) {
  .perf-header {
    padding: 60px 0;
    height: 750px;
    background: linear-gradient(to bottom, var(--background-red) 0 50%, var(--background-dark) 50% 100%);
    > .container {
      .content {
        min-width: 45%;
        max-width: 45%;
        > .upper {
          height: 315px;
          .line-one {
            font-size: 40px;
            line-height: 1.5;
            margin-bottom: 0.5em;
          }
        }
        > .lower {
          height: 315px;
        }
      }
      .image {
        flex: 1 0 auto;
        height: auto;
        margin: 0 16px 16px;
      }
    }
  }
}
</style>
